import { ReactComponent as SvgAdjustmentsOutline } from './AdjustmentsOutline.svg.es.js';
import { ReactComponent as SvgArchiveOutline } from './ArchiveOutline.svg.es.js';
import { ReactComponent as SvgArrowCircleUpOutline } from './ArrowCircleUpOutline.svg.es.js';
import { ReactComponent as SvgArrowDownSolid } from './ArrowDownSolid.svg.es.js';
import { ReactComponent as SvgArrowLeftOutline } from './ArrowLeftOutline.svg.es.js';
import { ReactComponent as SvgArrowLeftSolid } from './ArrowLeftSolid.svg.es.js';
import { ReactComponent as SvgArrowNarrowLeftSolid } from './ArrowNarrowLeftSolid.svg.es.js';
import { ReactComponent as SvgArrowNarrowRightSolid } from './ArrowNarrowRightSolid.svg.es.js';
import { ReactComponent as SvgArrowRightOutline } from './ArrowRightOutline.svg.es.js';
import { ReactComponent as SvgArrowRightSolid } from './ArrowRightSolid.svg.es.js';
import { ReactComponent as SvgArrowSmBottomLeftSolid } from './ArrowSmBottomLeftSolid.svg.es.js';
import { ReactComponent as SvgArrowSmDownOutline } from './ArrowSmDownOutline.svg.es.js';
import { ReactComponent as SvgArrowSmTopRightSolid } from './ArrowSmTopRightSolid.svg.es.js';
import { ReactComponent as SvgArrowSmUpSolid } from './ArrowSmUpSolid.svg.es.js';
import { ReactComponent as SvgArrowUpSolid } from './ArrowUpSolid.svg.es.js';
import { ReactComponent as SvgArrowsExpandDiagonalOutline } from './ArrowsExpandDiagonalOutline.svg.es.js';
import { ReactComponent as SvgArrowsExpandOutline } from './ArrowsExpandOutline.svg.es.js';
import { ReactComponent as SvgBadgeCheckOutline } from './BadgeCheckOutline.svg.es.js';
import { ReactComponent as SvgBeakerOutline } from './BeakerOutline.svg.es.js';
import { ReactComponent as SvgBellOutline } from './BellOutline.svg.es.js';
import { ReactComponent as SvgBookOpenOutline } from './BookOpenOutline.svg.es.js';
import { ReactComponent as SvgBroadcastSolid } from './BroadcastSolid.svg.es.js';
import { ReactComponent as SvgBullhornOutline } from './BullhornOutline.svg.es.js';
import { ReactComponent as SvgCalendarOutline } from './CalendarOutline.svg.es.js';
import { ReactComponent as SvgCardSolid } from './CardSolid.svg.es.js';
import { ReactComponent as SvgChartBarOutline } from './ChartBarOutline.svg.es.js';
import { ReactComponent as SvgChartBarSolid } from './ChartBarSolid.svg.es.js';
import { ReactComponent as SvgChartTrendingUpOutline } from './ChartTrendingUpOutline.svg.es.js';
import { ReactComponent as SvgChatOutline } from './ChatOutline.svg.es.js';
import { ReactComponent as SvgCheckCircleOutline } from './CheckCircleOutline.svg.es.js';
import { ReactComponent as SvgCheckCircleSolid } from './CheckCircleSolid.svg.es.js';
import { ReactComponent as SvgCheckOutline } from './CheckOutline.svg.es.js';
import { ReactComponent as SvgCheckboxCheckSolid } from './CheckboxCheckSolid.svg.es.js';
import { ReactComponent as SvgCheckboxIndeterminateSolid } from './CheckboxIndeterminateSolid.svg.es.js';
import { ReactComponent as SvgChevronDownOutline } from './ChevronDownOutline.svg.es.js';
import { ReactComponent as SvgChevronDownSolid } from './ChevronDownSolid.svg.es.js';
import { ReactComponent as SvgChevronLeftOutline } from './ChevronLeftOutline.svg.es.js';
import { ReactComponent as SvgChevronLeftSolid } from './ChevronLeftSolid.svg.es.js';
import { ReactComponent as SvgChevronRightOutline } from './ChevronRightOutline.svg.es.js';
import { ReactComponent as SvgChevronRightSolid } from './ChevronRightSolid.svg.es.js';
import { ReactComponent as SvgChevronUpOutline } from './ChevronUpOutline.svg.es.js';
import { ReactComponent as SvgChevronUpSolid } from './ChevronUpSolid.svg.es.js';
import { ReactComponent as SvgCircleSpinnerSolid } from './CircleSpinnerSolid.svg.es.js';
import { ReactComponent as SvgClipboardCheckOutline } from './ClipboardCheckOutline.svg.es.js';
import { ReactComponent as SvgClipboardListOutline } from './ClipboardListOutline.svg.es.js';
import { ReactComponent as SvgClipboardListSolid } from './ClipboardListSolid.svg.es.js';
import { ReactComponent as SvgClockNavOutline } from './ClockNavOutline.svg.es.js';
import { ReactComponent as SvgClockOutline } from './ClockOutline.svg.es.js';
import { ReactComponent as SvgClockSolid } from './ClockSolid.svg.es.js';
import { ReactComponent as SvgCloudSolid } from './CloudSolid.svg.es.js';
import { ReactComponent as SvgCodeOutline } from './CodeOutline.svg.es.js';
import { ReactComponent as SvgCogOutline } from './CogOutline.svg.es.js';
import { ReactComponent as SvgCogSolid } from './CogSolid.svg.es.js';
import { ReactComponent as SvgCoinOutline } from './CoinOutline.svg.es.js';
import { ReactComponent as SvgCollectionOutline } from './CollectionOutline.svg.es.js';
import { ReactComponent as SvgComputerOutline } from './ComputerOutline.svg.es.js';
import { ReactComponent as SvgContractOutline } from './ContractOutline.svg.es.js';
import { ReactComponent as SvgCreditCardOutline } from './CreditCardOutline.svg.es.js';
import { ReactComponent as SvgCubeTransparentOutline } from './CubeTransparentOutline.svg.es.js';
import { ReactComponent as SvgCurrencyDollarOutline } from './CurrencyDollarOutline.svg.es.js';
import { ReactComponent as SvgCurrencyEuroOutline } from './CurrencyEuroOutline.svg.es.js';
import { ReactComponent as SvgCurrencyExchangeSolid } from './CurrencyExchangeSolid.svg.es.js';
import { ReactComponent as SvgCustodyOutline } from './CustodyOutline.svg.es.js';
import { ReactComponent as SvgDeviceMobileOutline } from './DeviceMobileOutline.svg.es.js';
import { ReactComponent as SvgDeviceMobileSolid } from './DeviceMobileSolid.svg.es.js';
import { ReactComponent as SvgDocumentSearchOutline } from './DocumentSearchOutline.svg.es.js';
import { ReactComponent as SvgDocumentTextOutline } from './DocumentTextOutline.svg.es.js';
import { ReactComponent as SvgDocumentsOutline } from './DocumentsOutline.svg.es.js';
import { ReactComponent as SvgDotsHorizontalSolid } from './DotsHorizontalSolid.svg.es.js';
import { ReactComponent as SvgDotsVerticalSolid } from './DotsVerticalSolid.svg.es.js';
import { ReactComponent as SvgDownloadSolid } from './DownloadSolid.svg.es.js';
import { ReactComponent as SvgDuplicateOutline } from './DuplicateOutline.svg.es.js';
import { ReactComponent as SvgDuplicateSolid } from './DuplicateSolid.svg.es.js';
import { ReactComponent as SvgEllipseOutline } from './EllipseOutline.svg.es.js';
import { ReactComponent as SvgEllipseSolid } from './EllipseSolid.svg.es.js';
import { ReactComponent as SvgExchangeSolid } from './ExchangeSolid.svg.es.js';
import { ReactComponent as SvgExclamationCircleOutline } from './ExclamationCircleOutline.svg.es.js';
import { ReactComponent as SvgExclamationCircleSolid } from './ExclamationCircleSolid.svg.es.js';
import { ReactComponent as SvgExclamationOutline } from './ExclamationOutline.svg.es.js';
import { ReactComponent as SvgExclamationSolid } from './ExclamationSolid.svg.es.js';
import { ReactComponent as SvgExternalLinkOutline } from './ExternalLinkOutline.svg.es.js';
import { ReactComponent as SvgEyeOffSolid } from './EyeOffSolid.svg.es.js';
import { ReactComponent as SvgEyeSolid } from './EyeSolid.svg.es.js';
import { ReactComponent as SvgFaucetSolid } from './FaucetSolid.svg.es.js';
import { ReactComponent as SvgFeeOutline } from './FeeOutline.svg.es.js';
import { ReactComponent as SvgFileSolid } from './FileSolid.svg.es.js';
import { ReactComponent as SvgFilterSolid } from './FilterSolid.svg.es.js';
import { ReactComponent as SvgFingerprintOutline } from './FingerprintOutline.svg.es.js';
import { ReactComponent as SvgFingerprintSolid } from './FingerprintSolid.svg.es.js';
import { ReactComponent as SvgFlagOutline } from './FlagOutline.svg.es.js';
import { ReactComponent as SvgFlagSolid } from './FlagSolid.svg.es.js';
import { ReactComponent as SvgFolderOpenSolid } from './FolderOpenSolid.svg.es.js';
import { ReactComponent as SvgFolderSolid } from './FolderSolid.svg.es.js';
import { ReactComponent as SvgGamingOutline } from './GamingOutline.svg.es.js';
import { ReactComponent as SvgGasPumpOutline } from './GasPumpOutline.svg.es.js';
import { ReactComponent as SvgGasPumpSolid } from './GasPumpSolid.svg.es.js';
import { ReactComponent as SvgGiftOutline } from './GiftOutline.svg.es.js';
import { ReactComponent as SvgGiftSolid } from './GiftSolid.svg.es.js';
import { ReactComponent as SvgGlobeAltOutline } from './GlobeAltOutline.svg.es.js';
import { ReactComponent as SvgGlobeOutline } from './GlobeOutline.svg.es.js';
import { ReactComponent as SvgGovernment } from './Government.svg.es.js';
import { ReactComponent as SvgGraphIncreaseOutline } from './GraphIncreaseOutline.svg.es.js';
import { ReactComponent as SvgHashtagOutline } from './HashtagOutline.svg.es.js';
import { ReactComponent as SvgHomeOutline } from './HomeOutline.svg.es.js';
import { ReactComponent as SvgIndeterminateSolid } from './IndeterminateSolid.svg.es.js';
import { ReactComponent as SvgInformationCircleOutline } from './InformationCircleOutline.svg.es.js';
import { ReactComponent as SvgInformationCircleSolid } from './InformationCircleSolid.svg.es.js';
import { ReactComponent as SvgKeyOutline } from './KeyOutline.svg.es.js';
import { ReactComponent as SvgKeySolid } from './KeySolid.svg.es.js';
import { ReactComponent as SvgLaunchOutline } from './LaunchOutline.svg.es.js';
import { ReactComponent as SvgLibraryOutline } from './LibraryOutline.svg.es.js';
import { ReactComponent as SvgLibrarySolid } from './LibrarySolid.svg.es.js';
import { ReactComponent as SvgLightBulbOutline } from './LightBulbOutline.svg.es.js';
import { ReactComponent as SvgLightningBoltOutline } from './LightningBoltOutline.svg.es.js';
import { ReactComponent as SvgLightningBoltSolid } from './LightningBoltSolid.svg.es.js';
import { ReactComponent as SvgLinkOutline } from './LinkOutline.svg.es.js';
import { ReactComponent as SvgLocationMarkerOutline } from './LocationMarkerOutline.svg.es.js';
import { ReactComponent as SvgLockClosedOutline } from './LockClosedOutline.svg.es.js';
import { ReactComponent as SvgLockClosedSolid } from './LockClosedSolid.svg.es.js';
import { ReactComponent as SvgLockOpenSolid } from './LockOpenSolid.svg.es.js';
import { ReactComponent as SvgLoginSolid } from './LoginSolid.svg.es.js';
import { ReactComponent as SvgLogoutOutline } from './LogoutOutline.svg.es.js';
import { ReactComponent as SvgMailOutline } from './MailOutline.svg.es.js';
import { ReactComponent as SvgMailSolid } from './MailSolid.svg.es.js';
import { ReactComponent as SvgMenuAlt2Outline } from './MenuAlt2Outline.svg.es.js';
import { ReactComponent as SvgMinusSolid } from './MinusSolid.svg.es.js';
import { ReactComponent as SvgMoonOutline } from './MoonOutline.svg.es.js';
import { ReactComponent as SvgMoveSolid } from './MoveSolid.svg.es.js';
import { ReactComponent as SvgMultiTokenOutline } from './MultiTokenOutline.svg.es.js';
import { ReactComponent as SvgNftOutline } from './NFTOutline.svg.es.js';
import { ReactComponent as SvgNumber1Solid } from './Number1Solid.svg.es.js';
import { ReactComponent as SvgNumber2Solid } from './Number2Solid.svg.es.js';
import { ReactComponent as SvgNumber3Solid } from './Number3Solid.svg.es.js';
import { ReactComponent as SvgOfficeBuildingOutline } from './OfficeBuildingOutline.svg.es.js';
import { ReactComponent as SvgOfficeBuildingSolid } from './OfficeBuildingSolid.svg.es.js';
import { ReactComponent as SvgPaperAirPlaneSolid } from './PaperAirPlaneSolid.svg.es.js';
import { ReactComponent as SvgPaperAirplaneLeftOutline } from './PaperAirplaneLeftOutline.svg.es.js';
import { ReactComponent as SvgPaperAirplaneRightOutline } from './PaperAirplaneRightOutline.svg.es.js';
import { ReactComponent as SvgPencilOutline } from './PencilOutline.svg.es.js';
import { ReactComponent as SvgPencilSolid } from './PencilSolid.svg.es.js';
import { ReactComponent as SvgPlayOutline } from './PlayOutline.svg.es.js';
import { ReactComponent as SvgPlusCircleOutline } from './PlusCircleOutline.svg.es.js';
import { ReactComponent as SvgPlusSolid } from './PlusSolid.svg.es.js';
import { ReactComponent as SvgPresentationChartLineOutline } from './PresentationChartLineOutline.svg.es.js';
import { ReactComponent as SvgPuzzleOutline } from './PuzzleOutline.svg.es.js';
import { ReactComponent as SvgQrCodeSolid } from './QRCodeSolid.svg.es.js';
import { ReactComponent as SvgQuestionMarkCircleOutline } from './QuestionMarkCircleOutline.svg.es.js';
import { ReactComponent as SvgQuestionMarkCircleSolid } from './QuestionMarkCircleSolid.svg.es.js';
import { ReactComponent as SvgRssOutline } from './RSSOutline.svg.es.js';
import { ReactComponent as SvgReceiptInvoiceOutline } from './ReceiptInvoiceOutline.svg.es.js';
import { ReactComponent as SvgRefreshOutline } from './RefreshOutline.svg.es.js';
import { ReactComponent as SvgSearchCircleOutline } from './SearchCircleOutline.svg.es.js';
import { ReactComponent as SvgSearchOutline } from './SearchOutline.svg.es.js';
import { ReactComponent as SvgServerOutline } from './ServerOutline.svg.es.js';
import { ReactComponent as SvgShareOutline } from './ShareOutline.svg.es.js';
import { ReactComponent as SvgShieldCheckOutline } from './ShieldCheckOutline.svg.es.js';
import { ReactComponent as SvgShieldCheckSolid } from './ShieldCheckSolid.svg.es.js';
import { ReactComponent as SvgShieldExclamationOutline } from './ShieldExclamationOutline.svg.es.js';
import { ReactComponent as SvgShoppingCartOutline } from './ShoppingCartOutline.svg.es.js';
import { ReactComponent as SvgSnowflakeOutline } from './SnowflakeOutline.svg.es.js';
import { ReactComponent as SvgSparklesOutline } from './SparklesOutline.svg.es.js';
import { ReactComponent as SvgSpeakerphoneSolid } from './SpeakerphoneSolid.svg.es.js';
import { ReactComponent as SvgStarOutline } from './StarOutline.svg.es.js';
import { ReactComponent as SvgSubtitlesSolid } from './SubtitlesSolid.svg.es.js';
import { ReactComponent as SvgSuccessOutline } from './SuccessOutline.svg.es.js';
import { ReactComponent as SvgSunOutline } from './SunOutline.svg.es.js';
import { ReactComponent as SvgSupportSolid } from './SupportSolid.svg.es.js';
import { ReactComponent as SvgSwitchHorizontalOutline } from './SwitchHorizontalOutline.svg.es.js';
import { ReactComponent as SvgSwitchVerticalOutline } from './SwitchVerticalOutline.svg.es.js';
import { ReactComponent as SvgSwitchVerticalSolid } from './SwitchVerticalSolid.svg.es.js';
import { ReactComponent as SvgTagOutline } from './TagOutline.svg.es.js';
import { ReactComponent as SvgTemplateOutline } from './TemplateOutline.svg.es.js';
import { ReactComponent as SvgTemplateSolid } from './TemplateSolid.svg.es.js';
import { ReactComponent as SvgTerminalOutline } from './TerminalOutline.svg.es.js';
import { ReactComponent as SvgTerminalSolid } from './TerminalSolid.svg.es.js';
import { ReactComponent as SvgThumbsDownOutline } from './ThumbsDownOutline.svg.es.js';
import { ReactComponent as SvgThumbsUpOutline } from './ThumbsUpOutline.svg.es.js';
import { ReactComponent as SvgTokenSolid } from './TokenSolid.svg.es.js';
import { ReactComponent as SvgTransactionOutline } from './TransactionOutline.svg.es.js';
import { ReactComponent as SvgTrashOutline } from './TrashOutline.svg.es.js';
import { ReactComponent as SvgTrashSolid } from './TrashSolid.svg.es.js';
import { ReactComponent as SvgTrendingDownOutline } from './TrendingDownOutline.svg.es.js';
import { ReactComponent as SvgTrendingUpOutline } from './TrendingUpOutline.svg.es.js';
import { ReactComponent as SvgTrendingUpSolid } from './TrendingUpSolid.svg.es.js';
import { ReactComponent as SvgUsdcOutline } from './USDCOutline.svg.es.js';
import { ReactComponent as SvgUndoOutline } from './UndoOutline.svg.es.js';
import { ReactComponent as SvgUserCircleOutline } from './UserCircleOutline.svg.es.js';
import { ReactComponent as SvgUserGroupOutline } from './UserGroupOutline.svg.es.js';
import { ReactComponent as SvgUserOutline } from './UserOutline.svg.es.js';
import { ReactComponent as SvgUserSolid } from './UserSolid.svg.es.js';
import { ReactComponent as SvgUsersOutline } from './UsersOutline.svg.es.js';
import { ReactComponent as SvgVariableOutline } from './VariableOutline.svg.es.js';
import { ReactComponent as SvgVaultSolid } from './VaultSolid.svg.es.js';
import { ReactComponent as SvgViewGridOutline } from './ViewGridOutline.svg.es.js';
import { ReactComponent as SvgWalletOutline } from './WalletOutline.svg.es.js';
import { ReactComponent as SvgWalletSolid } from './WalletSolid.svg.es.js';
import { ReactComponent as SvgWithdrawalSolid } from './WithdrawalSolid.svg.es.js';
import { ReactComponent as SvgXCircleOutline } from './XCircleOutline.svg.es.js';
import { ReactComponent as SvgXCircleSolid } from './XCircleSolid.svg.es.js';
import { ReactComponent as SvgXSolid } from './XSolid.svg.es.js';

const SvgCommonIcons = {
    AdjustmentsOutline: SvgAdjustmentsOutline,
    ArchiveOutline: SvgArchiveOutline,
    ArrowCircleUpOutline: SvgArrowCircleUpOutline,
    ArrowDownSolid: SvgArrowDownSolid,
    ArrowsExpandDiagonalOutline: SvgArrowsExpandDiagonalOutline,
    ArrowsExpandOutline: SvgArrowsExpandOutline,
    ArrowLeftOutline: SvgArrowLeftOutline,
    ArrowLeftSolid: SvgArrowLeftSolid,
    ArrowRightOutline: SvgArrowRightOutline,
    ArrowRightSolid: SvgArrowRightSolid,
    ArrowSmBottomLeftSolid: SvgArrowSmBottomLeftSolid,
    ArrowSmDownOutline: SvgArrowSmDownOutline,
    ArrowSmTopRightSolid: SvgArrowSmTopRightSolid,
    ArrowSmUpSolid: SvgArrowSmUpSolid,
    ArrowNarrowLeftSolid: SvgArrowNarrowLeftSolid,
    ArrowNarrowRightSolid: SvgArrowNarrowRightSolid,
    ArrowUpSolid: SvgArrowUpSolid,
    BadgeCheckOutline: SvgBadgeCheckOutline,
    BeakerOutline: SvgBeakerOutline,
    BellOutline: SvgBellOutline,
    BookOpenOutline: SvgBookOpenOutline,
    BroadcastSolid: SvgBroadcastSolid,
    BullhornOutline: SvgBullhornOutline,
    CalendarOutline: SvgCalendarOutline,
    CardSolid: SvgCardSolid,
    ChartBarOutline: SvgChartBarOutline,
    ChartBarSolid: SvgChartBarSolid,
    ChartTrendingUpOutline: SvgChartTrendingUpOutline,
    ChatOutline: SvgChatOutline,
    CheckboxCheckSolid: SvgCheckboxCheckSolid,
    CheckboxIndeterminateSolid: SvgCheckboxIndeterminateSolid,
    CheckCircleOutline: SvgCheckCircleOutline,
    CheckCircleSolid: SvgCheckCircleSolid,
    CheckOutline: SvgCheckOutline,
    ChevronLeftOutline: SvgChevronLeftOutline,
    ChevronDownOutline: SvgChevronDownOutline,
    ChevronRightOutline: SvgChevronRightOutline,
    ChevronUpOutline: SvgChevronUpOutline,
    ChevronLeftSolid: SvgChevronLeftSolid,
    ChevronDownSolid: SvgChevronDownSolid,
    ChevronRightSolid: SvgChevronRightSolid,
    ChevronUpSolid: SvgChevronUpSolid,
    CircleSpinnerSolid: SvgCircleSpinnerSolid,
    ClipboardCheckOutline: SvgClipboardCheckOutline,
    ClipboardListOutline: SvgClipboardListOutline,
    ClipboardListSolid: SvgClipboardListSolid,
    ClockNavOutline: SvgClockNavOutline,
    ClockOutline: SvgClockOutline,
    ClockSolid: SvgClockSolid,
    CloudSolid: SvgCloudSolid,
    CodeOutline: SvgCodeOutline,
    CogOutline: SvgCogOutline,
    CogSolid: SvgCogSolid,
    CoinOutline: SvgCoinOutline,
    CollectionOutline: SvgCollectionOutline,
    ComputerOutline: SvgComputerOutline,
    ContractOutline: SvgContractOutline,
    CreditCardOutline: SvgCreditCardOutline,
    CubeTransparentOutline: SvgCubeTransparentOutline,
    CurrencyDollarOutline: SvgCurrencyDollarOutline,
    CurrencyEuroOutline: SvgCurrencyEuroOutline,
    CurrencyExchangeSolid: SvgCurrencyExchangeSolid,
    CustodyOutline: SvgCustodyOutline,
    DeviceMobileOutline: SvgDeviceMobileOutline,
    DeviceMobileSolid: SvgDeviceMobileSolid,
    DocumentSearchOutline: SvgDocumentSearchOutline,
    DocumentTextOutline: SvgDocumentTextOutline,
    DocumentsOutline: SvgDocumentsOutline,
    DotsHorizontalSolid: SvgDotsHorizontalSolid,
    DotsVerticalSolid: SvgDotsVerticalSolid,
    DownloadSolid: SvgDownloadSolid,
    DuplicateOutline: SvgDuplicateOutline,
    DuplicateSolid: SvgDuplicateSolid,
    EllipseOutline: SvgEllipseOutline,
    EllipseSolid: SvgEllipseSolid,
    ExclamationCircleOutline: SvgExclamationCircleOutline,
    ExclamationCircleSolid: SvgExclamationCircleSolid,
    ExclamationOutline: SvgExclamationOutline,
    ExclamationSolid: SvgExclamationSolid,
    ExchangeSolid: SvgExchangeSolid,
    ExternalLinkOutline: SvgExternalLinkOutline,
    EyeOffSolid: SvgEyeOffSolid,
    EyeSolid: SvgEyeSolid,
    FaucetSolid: SvgFaucetSolid,
    FeeOutline: SvgFeeOutline,
    FileSolid: SvgFileSolid,
    FilterSolid: SvgFilterSolid,
    FingerprintOutline: SvgFingerprintOutline,
    FingerprintSolid: SvgFingerprintSolid,
    FlagOutline: SvgFlagOutline,
    FlagSolid: SvgFlagSolid,
    FolderOpenSolid: SvgFolderOpenSolid,
    FolderSolid: SvgFolderSolid,
    GamingOutline: SvgGamingOutline,
    GasPumpOutline: SvgGasPumpOutline,
    GasPumpSolid: SvgGasPumpSolid,
    GiftOutline: SvgGiftOutline,
    GiftSolid: SvgGiftSolid,
    GlobeAltOutline: SvgGlobeAltOutline,
    GlobeOutline: SvgGlobeOutline,
    GovernmentOutline: SvgGovernment,
    GraphIncreaseOutline: SvgGraphIncreaseOutline,
    HashtagOutline: SvgHashtagOutline,
    HomeOutline: SvgHomeOutline,
    IndeterminateSolid: SvgIndeterminateSolid,
    InformationCircleOutline: SvgInformationCircleOutline,
    InformationCircleSolid: SvgInformationCircleSolid,
    KeyOutline: SvgKeyOutline,
    KeySolid: SvgKeySolid,
    LaunchOutline: SvgLaunchOutline,
    LibraryOutline: SvgLibraryOutline,
    LibrarySolid: SvgLibrarySolid,
    LightningBoltOutline: SvgLightningBoltOutline,
    LightningBoltSolid: SvgLightningBoltSolid,
    LightBulbOutline: SvgLightBulbOutline,
    LinkOutline: SvgLinkOutline,
    LocationMarkerOutline: SvgLocationMarkerOutline,
    LockClosedOutline: SvgLockClosedOutline,
    LockClosedSolid: SvgLockClosedSolid,
    LockOpenSolid: SvgLockOpenSolid,
    LoginSolid: SvgLoginSolid,
    LogoutOutline: SvgLogoutOutline,
    MenuAlt2Outline: SvgMenuAlt2Outline,
    MailOutline: SvgMailOutline,
    MailSolid: SvgMailSolid,
    MinusSolid: SvgMinusSolid,
    MoonOutline: SvgMoonOutline,
    MoveSolid: SvgMoveSolid,
    MultiTokenOutline: SvgMultiTokenOutline,
    NFTOutline: SvgNftOutline,
    Number1Solid: SvgNumber1Solid,
    Number2Solid: SvgNumber2Solid,
    Number3Solid: SvgNumber3Solid,
    OfficeBuildingOutline: SvgOfficeBuildingOutline,
    OfficeBuildingSolid: SvgOfficeBuildingSolid,
    PaperAirPlaneSolid: SvgPaperAirPlaneSolid,
    PaperAirplaneLeftOutline: SvgPaperAirplaneLeftOutline,
    PaperAirplaneRightOutline: SvgPaperAirplaneRightOutline,
    PencilOutline: SvgPencilOutline,
    PencilSolid: SvgPencilSolid,
    PlayOutline: SvgPlayOutline,
    PlusCircleOutline: SvgPlusCircleOutline,
    PlusSolid: SvgPlusSolid,
    PresentationChartLineOutline: SvgPresentationChartLineOutline,
    PuzzleOutline: SvgPuzzleOutline,
    QRCodeSolid: SvgQrCodeSolid,
    QuestionMarkCircleOutline: SvgQuestionMarkCircleOutline,
    QuestionMarkCircleSolid: SvgQuestionMarkCircleSolid,
    ReceiptInvoiceOutline: SvgReceiptInvoiceOutline,
    RefreshOutline: SvgRefreshOutline,
    RSSOutline: SvgRssOutline,
    SearchCircleOutline: SvgSearchCircleOutline,
    SearchOutline: SvgSearchOutline,
    ShareOutline: SvgShareOutline,
    ServerOutline: SvgServerOutline,
    ShieldCheckOutline: SvgShieldCheckOutline,
    ShieldCheckSolid: SvgShieldCheckSolid,
    ShieldExclamationOutline: SvgShieldExclamationOutline,
    ShoppingCartOutline: SvgShoppingCartOutline,
    SnowflakeOutline: SvgSnowflakeOutline,
    SparklesOutline: SvgSparklesOutline,
    SpeakerphoneSolid: SvgSpeakerphoneSolid,
    StarOutline: SvgStarOutline,
    SubtitlesSolid: SvgSubtitlesSolid,
    SuccessOutline: SvgSuccessOutline,
    SunOutline: SvgSunOutline,
    SupportSolid: SvgSupportSolid,
    SwitchHorizontalOutline: SvgSwitchHorizontalOutline,
    SwitchVerticalOutline: SvgSwitchVerticalOutline,
    SwitchVerticalSolid: SvgSwitchVerticalSolid,
    TagOutline: SvgTagOutline,
    TemplateOutline: SvgTemplateOutline,
    TemplateSolid: SvgTemplateSolid,
    TerminalOutline: SvgTerminalOutline,
    TerminalSolid: SvgTerminalSolid,
    ThumbsDownOutline: SvgThumbsDownOutline,
    ThumbsUpOutline: SvgThumbsUpOutline,
    TokenSolid: SvgTokenSolid,
    TransactionOutline: SvgTransactionOutline,
    TrashOutline: SvgTrashOutline,
    TrashSolid: SvgTrashSolid,
    TrendingDownOutline: SvgTrendingDownOutline,
    TrendingUpOutline: SvgTrendingUpOutline,
    TrendingUpSolid: SvgTrendingUpSolid,
    USDCOutline: SvgUsdcOutline,
    UndoOutline: SvgUndoOutline,
    UserGroupOutline: SvgUserGroupOutline,
    UserOutline: SvgUserOutline,
    UserSolid: SvgUserSolid,
    UsersOutline: SvgUsersOutline,
    UserCircleOutline: SvgUserCircleOutline,
    ViewGridOutline: SvgViewGridOutline,
    VariableOutline: SvgVariableOutline,
    VaultSolid: SvgVaultSolid,
    WalletOutline: SvgWalletOutline,
    WalletSolid: SvgWalletSolid,
    WithdrawalSolid: SvgWithdrawalSolid,
    XCircleOutline: SvgXCircleOutline,
    XCircleSolid: SvgXCircleSolid,
    XSolid: SvgXSolid
};

export { SvgCommonIcons };
//# sourceMappingURL=index.es.js.map
